export class EncapsuleFailure {
    static PIECE_OUT_OF_STOCK = () => $localize `You do not have pieces of this type anymore.`;
    static INVALID_PLACEMENT = () => $localize `You must put your piece on an empty square or on a smaller piece.`;
    static NOT_DROPPABLE = () => $localize `You must pick your piece among the remaining ones.`;
    static INVALID_PIECE_SELECTED = () => $localize `You must pick one of your remaining pieces or one piece on the board that is the biggest of its square.`;
    static END_YOUR_MOVE = () => $localize `You are performing a move, you must select a landing square.`;
}
